import React from 'react';
import { Shimmer, ShimmerElementType, ThemeProvider, mergeStyles } from '@fluentui/react';

const wrapperClass = mergeStyles({
  padding: 2,
  selectors: {
    '& > .ms-Shimmer-container': {
      margin: '10px 0',
    },
  },
});

const shimmerWithElement = [
  { type: ShimmerElementType.line, height: 80, width: 160 },
  { type: ShimmerElementType.gap, width: 12 },
  { type: ShimmerElementType.line, height: 80, width: 160 },
  { type: ShimmerElementType.gap, width: 12 },
  { type: ShimmerElementType.line, height: 80, width: 160 },
  { type: ShimmerElementType.gap, width: 12 },
  { type: ShimmerElementType.line, height: 80, width: 160 },
];

export function MetricPickerShimmer() {
  return (
    <ThemeProvider className={wrapperClass}>
      <Shimmer shimmerElements={shimmerWithElement} width="70%" />
    </ThemeProvider>
  );
}
